var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "website-train", class: { builderMode: _vm.builderMode } },
    [
      _vm.training
        ? _c("md-progress-bar", { attrs: { "md-mode": "indeterminate" } })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "d-flex gap-5 align-items-center" },
          [
            _vm.builderMode
              ? [
                  _vm.state && _vm.state.state !== "finished"
                    ? _c("i", { staticClass: "material-icons spin" }, [
                        _vm._v("autorenew"),
                      ])
                    : _c("i", { staticClass: "material-icons text-primary" }, [
                        _vm._v("public"),
                      ]),
                ]
              : _c(
                  "IconButton",
                  {
                    attrs: {
                      "on-click": function () {
                        return _vm.$emit("close")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("arrow_back_ios"),
                    ]),
                  ]
                ),
            _vm._v(" "),
            _c("div", { staticClass: "title" }, [_vm._v("Website")]),
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "description" }, [
          _vm._v(
            "Crawl your website’s content to get answers to popular user questions."
          ),
        ]),
      ]),
      _vm._v(" "),
      !_vm.started
        ? _c("div", { staticClass: "form" }, [
            _c(
              "div",
              { staticClass: "d-flex gap-5" },
              [
                _c("div", { staticClass: "search-wrapper" }, [
                  _c("div", { staticClass: "tpl-search" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.url,
                          expression: "url",
                        },
                      ],
                      attrs: {
                        type: "text",
                        placeholder: "Enter a URL address",
                      },
                      domProps: { value: _vm.url },
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.scrape.apply(null, arguments)
                        },
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.url = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                !_vm.builderMode
                  ? _c(
                      "SupsisButton",
                      {
                        attrs: { primary: "", disabled: _vm.started },
                        on: { click: _vm.scrape },
                      },
                      [_vm._v("\n                Train chatbot\n            ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("span", { staticClass: "description" }, [
              _vm._v(
                "\n            By sharing your URL, you confirm you have the necessary rights to share its content.\n        "
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.started && !!_vm.state
        ? _c(
            "div",
            { staticClass: "categories" },
            _vm._l(_vm.getCategories(), function (category) {
              return _c("div", { staticClass: "category-wrapper" }, [
                _c(
                  "div",
                  {
                    staticClass: "category",
                    class: {
                      "category-empty-state": _vm.state.state !== "finished",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "switch" },
                      [
                        _vm.state.state === "finished"
                          ? [
                              _c("a-switch", {
                                attrs: {
                                  checked: _vm.isCategoryEnabled(category),
                                  size: "small",
                                },
                                on: {
                                  click: function () {
                                    return _vm.toggleCategory(category)
                                  },
                                },
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(category)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "description" }, [
                      _vm.state.state === "finished"
                        ? _c(
                            "div",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.showingCategory = category
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.getCategoryPages(category).length
                                  ) +
                                  " pages\n                        "
                              ),
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("edit"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.state && _vm.state.state === "finished" && !_vm.builderMode
        ? _c("div", { staticClass: "select-panel-wrapper" }, [
            _c("div", { staticClass: "select-panel" }, [
              _c("div", { staticClass: "items-count" }, [
                _c("i", { staticClass: "material-icons" }, [_vm._v("check")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.getSelectedPageCount()) + " pages selected"
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "buttons" },
                [
                  _c(
                    "SupsisButton",
                    {
                      attrs: { disabled: _vm.training },
                      on: { click: _vm.completeTrain },
                    },
                    [_vm._v("Train chatbot")]
                  ),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showingCategory
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "category-list-view-modal",
                title:
                  'Train the bot with pages from the "' +
                  _vm.showingCategory +
                  '" category',
                "show-footer": false,
              },
              on: {
                cancel: function () {
                  return (_vm.showingCategory = null)
                },
              },
            },
            [
              _c("CategoryPageListView", {
                attrs: {
                  category: _vm.showingCategory,
                  pages: _vm.getCategoryPages(_vm.showingCategory),
                },
                model: {
                  value: _vm.disabledUrls,
                  callback: function ($$v) {
                    _vm.disabledUrls = $$v
                  },
                  expression: "disabledUrls",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }